import { Box, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";

import { OrganizationConfiguration, Action } from "./components";
import useCreateOrganization from "./hooks/useCreateOrganization";
import newOrganizationResolver from "../../../../libs/form-validations/organization";
import Breadcrumb from "./components/Breadcrumb";

import { Alert } from "../../../../shared";
import { useAuthorization } from "../../../../hooks";
import { ROLES } from "../../../../constants/permissions";

const INITIAL_VALUES = {
    Name: "",
    ShortName: "",
    Description: "",
    Website: "",
    LogoUrl: "",
    LogoFile: null,
    IsActive: true,
};

export default function Create() {
    const { hasRole } = useAuthorization();
    const isSuperAdmin = hasRole(ROLES.SUPER_ADMIN);
    const { handleCreateOrganization, createOrganizationSvc } = useCreateOrganization();

    const methods = useForm({
        resolver: newOrganizationResolver,
        defaultValues: INITIAL_VALUES,
    });

    const onSubmit = methods.handleSubmit(handleCreateOrganization);

    if (!isSuperAdmin) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage="Only Super Admin can create organizations." />
            </Box>
        );
    }

    return (
        <Box flex={1}>
            <Breadcrumb />

            <Divider />

            <Box p={3} pb={0}>
                <Typography level="title-lg">New Organization</Typography>
                <Typography level="body-sm">
                    Add the organization profile details used across the platform.
                </Typography>
            </Box>
            <Box component={"div"} ml={3} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <OrganizationConfiguration />
                            <Action api={createOrganizationSvc} />
                            <Alert
                                successMessage={createOrganizationSvc.isSuccess && "Organization created successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    createOrganizationSvc.isError && "Failed to create organization. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
